// One way to open the keep-wheels popup from anywhere (gallery card, Settings
// > Storage, right after a self-chosen downgrade, a blocked upload). The host
// mounted in App listens for this event.
export const OPEN_KEEP_WHEELS_EVENT = "iyuga:open-keep-wheels";

export const openKeepWheels = (detail = {}) => {
  if (typeof window === "undefined") return;
  window.dispatchEvent(new CustomEvent(OPEN_KEEP_WHEELS_EVENT, { detail }));
};
